/* global CXAApollo */
import PropTypes from "prop-types";
import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { intlShape, injectIntl, FormattedMessage } from "react-intl";
import LogoCxaMono from "assets/images/logo.tmp.svg";
import messages from "components/messagesDescription";
import { CLIENTS_EXCLUDED_FOR_PRIVACYLINK } from "../constants.js";
import FooterLogoPP from "./FooterLogoPP";
// On Login Page
// For all Clients and Distributor accounts (including Liberty), change to LOGO © 2017 CXA Group All Rights Reserved.

// On Footer Page
// For All clients change to LOGO © 2017 CXA Group All Rights Reserved.
// For Liberty change to LOGO © 2017 All Rights Reserved.

const buildString = (params = {}) =>
  [
    "FE",
    params.ENV || "unknown env",
    params.TAG || "unknown tag",
    params.COMMIT_HASH || "unknown commit hash",
  ].join(" - ");

const Footer = ({ client, faqLabel, faqUrl, intl }) => {
  const year = moment().format("Y");

  // TODO: Leave this comment here, if business decide to white label by hiding the footer
  //  We can customize it here
  // const copyrightCopy = client === "libertyxchange"
  //   ? intl.formatMessage(messages.copyrightText)
  //   : intl.formatMessage(messages.businessNameDescription);

  const copyrightCopy = intl.formatMessage(messages.businessNameDescription);
  const isCXAClient = client !== "libertyxchange";
  return (
    <footer className="footer-wrapper">
      <div className="o-wrapper">
        <div className="footer">
          {isCXAClient && (
            <div className="footer__copy">
              <FooterLogoPP aria-hidden={true} className="footer__logo" />{" "}
              <span role="img" aria-label="Copyright">
                {"\u00A9"}
              </span>
              {` ${year} `}
              {copyrightCopy}
            </div>
          )}
          <nav className="footer__nav">
            <input type="hidden" value={buildString(CXAApollo)} />
            <a
              className="footer__nav-item"
              href={intl.formatMessage(messages.termsLink)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormattedMessage {...messages.termsDescription} />
            </a>
            <a
              className="footer__nav-item"
              href={intl.formatMessage(messages.privacyLink)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormattedMessage {...messages.privacyDescription} />
            </a>
            <Link className="footer__nav-item" to="/contact">
              <FormattedMessage {...messages.contactDescription} />
            </Link>
            {faqLabel && faqUrl && (
              <a
                className="footer__nav-item"
                href={faqUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage id={faqLabel} defaultMessage={faqLabel} />
              </a>
            )}
          </nav>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  client: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  faqUrl: PropTypes.string,
  faqLabel: PropTypes.string,
};

export default injectIntl(Footer);



// WEBPACK FOOTER //
// ./components/common/Footer.js